import React, { useState } from "react";
import axios from "axios";

const countries = [
    { name: "Afghanistan", iso2: "AF", phoneCode: "93", currency: "AFN" },
    { name: "Albania", iso2: "AL", phoneCode: "355", currency: "ALL" },
    { name: "Algeria", iso2: "DZ", phoneCode: "213", currency: "DZD" },
    { name: "Andorra", iso2: "AD", phoneCode: "376", currency: "EUR" },
    { name: "Angola", iso2: "AO", phoneCode: "244", currency: "AOA" },
    { name: "Antigua and Barbuda", iso2: "AG", phoneCode: "1268", currency: "XCD" },
    { name: "Argentina", iso2: "AR", phoneCode: "54", currency: "ARS" },
    { name: "Armenia", iso2: "AM", phoneCode: "374", currency: "AMD" },
    { name: "Australia", iso2: "AU", phoneCode: "61", currency: "AUD" },
    { name: "Austria", iso2: "AT", phoneCode: "43", currency: "EUR" },
    { name: "Azerbaijan", iso2: "AZ", phoneCode: "994", currency: "AZN" },
    { name: "Bahamas", iso2: "BS", phoneCode: "1242", currency: "BSD" },
    { name: "Bahrain", iso2: "BH", phoneCode: "973", currency: "BHD" },
    { name: "Bangladesh", iso2: "BD", phoneCode: "880", currency: "BDT" },
    { name: "Barbados", iso2: "BB", phoneCode: "1246", currency: "BBD" },
    { name: "Belarus", iso2: "BY", phoneCode: "375", currency: "BYN" },
    { name: "Belgium", iso2: "BE", phoneCode: "32", currency: "EUR" },
    { name: "Belize", iso2: "BZ", phoneCode: "501", currency: "BZD" },
    { name: "Benin", iso2: "BJ", phoneCode: "229", currency: "XOF" },
    { name: "Bhutan", iso2: "BT", phoneCode: "975", currency: "BTN" },
    { name: "Bolivia", iso2: "BO", phoneCode: "591", currency: "BOB" },
    { name: "Bosnia and Herzegovina", iso2: "BA", phoneCode: "387", currency: "BAM" },
    { name: "Botswana", iso2: "BW", phoneCode: "267", currency: "BWP" },
    { name: "Brazil", iso2: "BR", phoneCode: "55", currency: "BRL" },
    { name: "Brunei", iso2: "BN", phoneCode: "673", currency: "BND" },
    { name: "Bulgaria", iso2: "BG", phoneCode: "359", currency: "BGN" },
    { name: "Burkina Faso", iso2: "BF", phoneCode: "226", currency: "BFA" },
    { name: "Burundi", iso2: "BI", phoneCode: "257", currency: "BIF" },
    { name: "Cambodia", iso2: "KH", phoneCode: "855", currency: "KHR" },
    { name: "Cameroon", iso2: "CM", phoneCode: "237", currency: "CMR" },
    { name: "Canada", iso2: "CA", phoneCode: "1", currency: "CAD" },
    { name: "Cape Verde", iso2: "CV", phoneCode: "238", currency: "CVE" },
    { name: "Central African Republic", iso2: "CF", phoneCode: "236", currency: "CAF" },
    { name: "Chad", iso2: "TD", phoneCode: "235", currency: "TCD" },
    { name: "Chile", iso2: "CL", phoneCode: "56", currency: "CLP" },
    { name: "China", iso2: "CN", phoneCode: "86", currency: "CNY" },
    { name: "Colombia", iso2: "CO", phoneCode: "57", currency: "COP" },
    { name: "Comoros", iso2: "KM", phoneCode: "269", currency: "COM" },
    { name: "Congo", iso2: "CG", phoneCode: "242", currency: "COG" },
    { name: "Congo (Democratic Republic)", iso2: "CD", phoneCode: "243", currency: "COD" },
    { name: "Costa Rica", iso2: "CR", phoneCode: "506", currency: "CRC" },
    { name: "Croatia", iso2: "HR", phoneCode: "385", currency: "HRK" },
    { name: "Cuba", iso2: "CU", phoneCode: "53", currency: "CUP" },
    { name: "Cyprus", iso2: "CY", phoneCode: "357", currency: "CYP" },
    { name: "Czech Republic", iso2: "CZ", phoneCode: "420", currency: "CZK" },
    { name: "Denmark", iso2: "DK", phoneCode: "45", currency: "DKK" },
    { name: "Djibouti", iso2: "DJ", phoneCode: "253", currency: "DJF" },
    { name: "Dominica", iso2: "DM", phoneCode: "1767", currency: "DMA" },
    { name: "Dominican Republic", iso2: "DO", phoneCode: "1", currency: "DOP" },
    { name: "Ecuador", iso2: "EC", phoneCode: "593", currency: "USD" },
    { name: "Egypt", iso2: "EG", phoneCode: "20", currency: "EGP" },
    { name: "El Salvador", iso2: "SV", phoneCode: "503", currency: "SVC" },
    { name: "Equatorial Guinea", iso2: "GQ", phoneCode: "240", currency: "GNF" },
    { name: "Eritrea", iso2: "ER", phoneCode: "291", currency: "ERN" },
    { name: "Estonia", iso2: "EE", phoneCode: "372", currency: "EST" },
    { name: "Ethiopia", iso2: "ET", phoneCode: "251", currency: "ETB" },
    { name: "Fiji", iso2: "FJ", phoneCode: "679", currency: "FJD" },
    { name: "Finland", iso2: "FI", phoneCode: "358", currency: "FIN" },
    { name: "France", iso2: "FR", phoneCode: "33", currency: "FRA" },
    { name: "Gabon", iso2: "GA", phoneCode: "241", currency: "GAB" },
    { name: "Gambia", iso2: "GM", phoneCode: "220", currency: "GMB" },
    { name: "Georgia", iso2: "GE", phoneCode: "995", currency: "GEO" },
    { name: "Germany", iso2: "DE", phoneCode: "49", currency: "DEU" },
    { name: "Ghana", iso2: "GH", phoneCode: "233", currency: "GHA" },
    { name: "Greece", iso2: "GR", phoneCode: "30", currency: "GRC" },
    { name: "Grenada", iso2: "GD", phoneCode: "1473", currency: "GRD" },
    { name: "Guatemala", iso2: "GT", phoneCode: "502", currency: "GTM" },
    { name: "Guinea", iso2: "GN", phoneCode: "224", currency: "GIN" },
    { name: "Guinea-Bissau", iso2: "GW", phoneCode: "245", currency: "GNB" },
    { name: "Guyana", iso2: "GY", phoneCode: "592", currency: "GUY" },
    { name: "Haiti", iso2: "HT", phoneCode: "509", currency: "HTI" },
    { name: "Honduras", iso2: "HN", phoneCode: "504", currency: "HND" },
    { name: "Hungary", iso2: "HU", phoneCode: "36", currency: "HUN" },
    { name: "Iceland", iso2: "IS", phoneCode: "354", currency: "ISK" },
    { name: "India", iso2: "IN", phoneCode: "91", currency: "INR" },
    { name: "Indonesia", iso2: "ID", phoneCode: "62", currency: "IDR" },
    { name: "Iran", iso2: "IR", phoneCode: "98", currency: "IRR" },
    { name: "Iraq", iso2: "IQ", phoneCode: "964", currency: "IQD" },
    { name: "Ireland", iso2: "IE", phoneCode: "353", currency: "EUR" },
    { name: "Italy", iso2: "IT", phoneCode: "39", currency: "EUR" },
    { name: "Jamaica", iso2: "JM", phoneCode: "1-876", currency: "JMD" },
    { name: "Japan", iso2: "JP", phoneCode: "81", currency: "JPY" },
    { name: "Jordan", iso2: "JO", phoneCode: "962", currency: "JOD" },
    { name: "Kazakhstan", iso2: "KZ", phoneCode: "7", currency: "KZT" },
    { name: "Kenya", iso2: "KE", phoneCode: "254", currency: "KES" },
    { name: "Kiribati", iso2: "KI", phoneCode: "686", currency: "AUD" },
    { name: "Kuwait", iso2: "KW", phoneCode: "965", currency: "KWD" },
    { name: "Kyrgyzstan", iso2: "KG", phoneCode: "996", currency: "KGS" },
    { name: "Laos", iso2: "LA", phoneCode: "856", currency: "LAK" },
    { name: "Latvia", iso2: "LV", phoneCode: "371", currency: "EUR" },
    { name: "Lebanon", iso2: "LB", phoneCode: "961", currency: "LBP" },
    { name: "Lesotho", iso2: "LS", phoneCode: "266", currency: "LSL" },
    { name: "Liberia", iso2: "LR", phoneCode: "231", currency: "LRD" },
    { name: "Libya", iso2: "LY", phoneCode: "218", currency: "LYD" },
    { name: "Liechtenstein", iso2: "LI", phoneCode: "423", currency: "CHF" },
    { name: "Lithuania", iso2: "LT", phoneCode: "370", currency: "EUR" },
    { name: "Luxembourg", iso2: "LU", phoneCode: "352", currency: "EUR" },
    { name: "Madagascar", iso2: "MG", phoneCode: "261", currency: "MGA" },
    { name: "Malawi", iso2: "MW", phoneCode: "265", currency: "MWK" },
    { name: "Malaysia", iso2: "MY", phoneCode: "60", currency: "MYR" },
    { name: "Malta", iso2: "MT", phoneCode: "356", currency: "EUR" },
    { name: "Marshall Islands", iso2: "MH", phoneCode: "692", currency: "USD" },
    { name: "Mauritania", iso2: "MR", phoneCode: "222", currency: "MRU" },
    { name: "Mauritius", iso2: "MU", phoneCode: "230", currency: "MUR" },
    { name: "Mexico", iso2: "MX", phoneCode: "52", currency: "MXN" },
    { name: "Micronesia", iso2: "FM", phoneCode: "691", currency: "USD" },
    { name: "Moldova", iso2: "MD", phoneCode: "373", currency: "MDL" },
    { name: "Monaco", iso2: "MC", phoneCode: "377", currency: "EUR" },
    { name: "Mongolia", iso2: "MN", phoneCode: "976", currency: "MNT" },
    { name: "Montenegro", iso2: "ME", phoneCode: "382", currency: "EUR" },
    { name: "Montserrat", iso2: "MS", phoneCode: "1-664", currency: "XCD" },
    { name: "Morocco", iso2: "MA", phoneCode: "212", currency: "MAD" },
    { name: "Mozambique", iso2: "MZ", phoneCode: "258", currency: "MZN" },
    { name: "Myanmar", iso2: "MM", phoneCode: "95", currency: "MMK" },
    { name: "Namibia", iso2: "NA", phoneCode: "264", currency: "NAD" },
    { name: "Nauru", iso2: "NR", phoneCode: "674", currency: "AUD" },
    { name: "Nepal", iso2: "NP", phoneCode: "977", currency: "NPR" },
    { name: "Netherlands", iso2: "NL", phoneCode: "31", currency: "EUR" },
    { name: "New Zealand", iso2: "NZ", phoneCode: "64", currency: "NZD" },
    { name: "Nicaragua", iso2: "NI", phoneCode: "505", currency: "NIO" },
    { name: "Niger", iso2: "NE", phoneCode: "227", currency: "NGA" },
    { name: "Nigeria", iso2: "NG", phoneCode: "234", currency: "NGN" },
    { name: "North Macedonia", iso2: "MK", phoneCode: "389", currency: "MKD" },
    { name: "Norway", iso2: "NO", phoneCode: "47", currency: "NOK" },
    { name: "Oman", iso2: "OM", phoneCode: "968", currency: "OMR" },
    { name: "Pakistan", iso2: "PK", phoneCode: "92", currency: "PKR" },
    { name: "Palau", iso2: "PW", phoneCode: "680", currency: "USD" },
    { name: "Panama", iso2: "PA", phoneCode: "507", currency: "PAB" },
    { name: "Papua New Guinea", iso2: "PG", phoneCode: "675", currency: "PGK" },
    { name: "Paraguay", iso2: "PY", phoneCode: "595", currency: "PYG" },
    { name: "Peru", iso2: "PE", phoneCode: "51", currency: "PEN" },
    { name: "Philippines", iso2: "PH", phoneCode: "63", currency: "PHP" },
    { name: "Poland", iso2: "PL", phoneCode: "48", currency: "PLN" },
    { name: "Portugal", iso2: "PT", phoneCode: "351", currency: "EUR" },
    { name: "Puerto Rico", iso2: "PR", phoneCode: "1-787", currency: "USD" },
    { name: "Qatar", iso2: "QA", phoneCode: "974", currency: "QAR" },
    { name: "Romania", iso2: "RO", phoneCode: "40", currency: "RON" },
    { name: "Russia", iso2: "RU", phoneCode: "7", currency: "RUB" },
    { name: "Rwanda", iso2: "RW", phoneCode: "250", currency: "RWF" },
    { name: "Saint Kitts and Nevis", iso2: "KN", phoneCode: "1-869", currency: "XCD" },
    { name: "Saint Lucia", iso2: "LC", phoneCode: "1-758", currency: "XCD" },
    { name: "Saint Vincent and the Grenadines", iso2: "VC", phoneCode: "1-784", currency: "XCD" },
    { name: "Samoa", iso2: "WS", phoneCode: "685", currency: "WST" },
    { name: "San Marino", iso2: "SM", phoneCode: "378", currency: "EUR" },
    { name: "São Tomé and Príncipe", iso2: "ST", phoneCode: "239", currency: "STN" },
    { name: "Saudi Arabia", iso2: "SA", phoneCode: "966", currency: "SAR" },
    { name: "Senegal", iso2: "SN", phoneCode: "221", currency: "XOF" },
    { name: "Serbia", iso2: "RS", phoneCode: "381", currency: "RSD" },
    { name: "Seychelles", iso2: "SC", phoneCode: "248", currency: "SCR" },
    { name: "Sierra Leone", iso2: "SL", phoneCode: "232", currency: "SLL" },
    { name: "Singapore", iso2: "SG", phoneCode: "65", currency: "SGD" },
    { name: "Slovakia", iso2: "SK", phoneCode: "421", currency: "EUR" },
    { name: "Slovenia", iso2: "SI", phoneCode: "386", currency: "EUR" },
    { name: "Solomon Islands", iso2: "SB", phoneCode: "677", currency: "SBD" },
    { name: "Somalia", iso2: "SO", phoneCode: "252", currency: "SOS" },
    { name: "South Africa", iso2: "ZA", phoneCode: "27", currency: "ZAR" },
    { name: "South Korea", iso2: "KR", phoneCode: "82", currency: "KRW" },
    { name: "South Sudan", iso2: "SS", phoneCode: "211", currency: "SSP" },
    { name: "Spain", iso2: "ES", phoneCode: "34", currency: "EUR" },
    { name: "Sri Lanka", iso2: "LK", phoneCode: "94", currency: "LKR" },
    { name: "Sudan", iso2: "SD", phoneCode: "249", currency: "SDG" },
    { name: "Suriname", iso2: "SR", phoneCode: "597", currency: "SRD" },
    { name: "Swaziland", iso2: "SZ", phoneCode: "268", currency: "SZL" },
    { name: "Sweden", iso2: "SE", phoneCode: "46", currency: "SEK" },
    { name: "Switzerland", iso2: "CH", phoneCode: "41", currency: "CHF" },
    { name: "Syria", iso2: "SY", phoneCode: "963", currency: "SYP" },
    { name: "Taiwan", iso2: "TW", phoneCode: "886", currency: "TWD" },
    { name: "Tajikistan", iso2: "TJ", phoneCode: "992", currency: "TJS" },
    { name: "Tanzania", iso2: "TZ", phoneCode: "255", currency: "TZS" },
    { name: "Thailand", iso2: "TH", phoneCode: "66", currency: "THB" },
    { name: "Togo", iso2: "TG", phoneCode: "228", currency: "XOF" },
    { name: "Tokelau", iso2: "TK", phoneCode: "690", currency: "NZD" },
    { name: "Tonga", iso2: "TO", phoneCode: "676", currency: "TOP" },
    { name: "Trinidad and Tobago", iso2: "TT", phoneCode: "1-868", currency: "TTD" },
    { name: "Tunisia", iso2: "TN", phoneCode: "216", currency: "TND" },
    { name: "Turkey", iso2: "TR", phoneCode: "90", currency: "TRY" },
    { name: "Turkmenistan", iso2: "TM", phoneCode: "993", currency: "TMT" },
    { name: "Tuvalu", iso2: "TV", phoneCode: "688", currency: "AUD" },
    { name: "Uganda", iso2: "UG", phoneCode: "256", currency: "UGX" },
    { name: "Ukraine", iso2: "UA", phoneCode: "380", currency: "UAH" },
    { name: "United Arab Emirates", iso2: "AE", phoneCode: "971", currency: "AED" },
    { name: "United Kingdom", iso2: "GB", phoneCode: "44", currency: "GBP" },
    { name: "United States", iso2: "US", phoneCode: "1", currency: "USD" },
    { name: "Uruguay", iso2: "UY", phoneCode: "598", currency: "UYU" },
    { name: "Uzbekistan", iso2: "UZ", phoneCode: "998", currency: "UZS" },
    { name: "Vanuatu", iso2: "VU", phoneCode: "678", currency: "VUV" },
    { name: "Vatican City", iso2: "VA", phoneCode: "39", currency: "EUR" },
    { name: "Venezuela", iso2: "VE", phoneCode: "58", currency: "VES" },
    { name: "Vietnam", iso2: "VN", phoneCode: "84", currency: "VND" },
    { name: "Wallis and Futuna", iso2: "WF", phoneCode: "681", currency: "XPF" },
    { name: "Western Sahara", iso2: "EH", phoneCode: "212", currency: "MAD" },
    { name: "Yemen", iso2: "YE", phoneCode: "967", currency: "YER" },
    { name: "Zambia", iso2: "ZM", phoneCode: "260", currency: "ZMW" },
    { name: "Zimbabwe", iso2: "ZW", phoneCode: "263", currency: "ZWL" }
];

export default function LeadAndConnectPage() {
    const [formData, setFormData] = useState({
        merchantName: "",
        country: "",
        email: "",
        currency: "",
        phoneCode: "",
        phoneNumber: ""
    });
const [loading, setLoading] = useState(false);
const [connectUrl, setConnectUrl] = useState("");
const [error, setError] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "country") {
            const selectedCountry = countries.find(c => c.iso2 === value);
            setFormData((prev) => ({
                ...prev,
                country: value,
                currency: selectedCountry?.currency || ""
            }));
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

   const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setConnectUrl("");
    setError("");

    try {
        const response = await axios.post("https://tp-api.alsendi.me/lead", {
            "country": formData.country,
            "brand": {
                "segment": {
                    "type": { "code": "non_profit" },
                    "team": { "code": "small" }
                },
                "name": [{ "text": formData.merchantName, "lang": "en" }],
                "terms": [{ "term": "general", "agree": true }]
            },
            "entity": { "carries_a_license": true },
            "wallet": { "currency": formData.currency },
            "users": [
                {
                    "contact": {
                        "email": [{ "address": formData.email, "primary": true }],
                        "phone": [{
                            "country_code": formData.phoneCode,
                            "number": formData.phoneNumber,
                            "primary": true
                        }]
                    },
                    "primary": true
                }
            ],
        });

        const url = response?.data?.connect?.url;
        if (url) {
            setConnectUrl(url);
        } else {
            setError("Connect URL not found in response.");
        }
    } catch (err) {
        console.error(err);
        setError("An error occurred while submitting the form.");
    } finally {
        setLoading(false);
    }
};


    return (
        <div className="App">
            <header className="App-header">
                <h1>Lead and Connect</h1>
                <h4>Developed By Ali AlSendi</h4>
            </header>
            <main className="App-main">

                <div className="card-container">
{loading && <p>Loading...</p>}

{connectUrl && (
    <p>
        Connect URL:{" "}
        <a href={connectUrl} target="_blank" rel="noopener noreferrer">
            {connectUrl}
        </a>
    </p>
)}

{error && <p style={{ color: "red" }}>{error}</p>}
                    <form onSubmit={handleSubmit} style={{ padding: "1em", maxWidth: "400px", margin: "0 auto" }}>
                        <div>
                            <label>Merchant Name:</label><br />
                            <input
                                type="text"
                                name="merchantName"
                                value={formData.merchantName}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div>
                            <label>Country:</label><br />
                            <select
                                name="country"
                                value={formData.country}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Select Country</option>
                                {countries.map((c) => (
                                    <option key={c.iso2} value={c.iso2}>
                                        {c.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div>
                            <label>Email:</label><br />
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div>
                            <label>Phone Number:</label><br />
                            <div style={{ display: "flex", gap: "5px" }}>
                                <select
                                    name="phoneCode"
                                    value={formData.phoneCode}
                                    onChange={handleChange}
                                    style={{ width: "50%" }}
                                    required
                                >
                                    <option value="">Code</option>
                                    {countries.map((c) => (
                                        <option key={c.iso2} value={c.phoneCode}>
                                            {c.name} {c.phoneCode}
                                        </option>
                                    ))}
                                </select>
                                <input
                                    type="tel"
                                    name="phoneNumber"
                                    value={formData.phoneNumber}
                                    onChange={handleChange}
                                    placeholder="Phone Number"
                                    style={{ width: "70%" }}
                                    required
                                />
                            </div>
                        </div>

                        <button type="submit" className="pay-button"
                            style={{ marginTop: "1em" }}>Submit</button>
                    </form>
                </div>
            </main>
        </div>
    );
}
